import Icon1 from "@assets/icons/Icon";
import React from "react";
import { COMPANY_TYPE_LABELS as companyTypeLabels } from "@constants/partnerTypes";
import { Org } from "types/org";
import {
  MemberUser,
  MemberAssignmentItem,
} from "../blocks/MemberAssignmentBlock";
import { StatusBlock } from "../blocks/Status";
import { ProjectSummary, PartnerInfos, Broadcast, EmailSent } from "types";
import type { Dossier, DossierTag } from "types/dossier";
import type { Ordre, OrdreTag, OrdreStatus } from "types/ordre";
import type { Vehicle, VehicleReservation, VehicleTag, VehicleStatus } from "types/garage/vehicules";

const projectStatusDisplay: Record<
  string,
  { label: string; type: "success" | "info" | "warning" | "error" | "default" | "step" }
> = {
  not_started: { label: "En attente", type: "default" },
  in_progress: { label: "En cours", type: "info" },
  delivered: { label: "Livré", type: "success" },
  completed: { label: "Terminé", type: "success" },
  sav: { label: "SAV", type: "warning" },
};

export type Folder = {
  id: string;
  ref?: any;
  infos: {
    general: {
      name: string;
      num: string;
      city: string;
      date?: { seconds: number };
    };
    photo_facade?: { url: string; id: string };
    commercial_id?: string;
    comptability_id?: string;
  };
  creation_date: { seconds: number };
  status: string;
  results: {
    mandatory_checks_conforme?: number;
    mandatory_checks_available?: number;
  };
  archived?: boolean;
};

export function transformProjectsToTable(
  allfolders: ProjectSummary[],
  activetab: any = "current",
  orgData: Org | null = null,
  searchValue: string = "",
  orgUsers: MemberUser[] = [],
) {
  try {
    if (searchValue !== "") {
      allfolders = allfolders.filter((folder: ProjectSummary) =>
        folder.infos.general.name.includes(searchValue),
      );
    }

    if (activetab && activetab !== "all") {
      allfolders = allfolders.filter(
        (folder: ProjectSummary) => folder.status === activetab,
      );
    }

    // Define columns for DataGrid, customize based on your data structure
    const columns = [
      { field: "id", headerName: "ID", width: 300 },
      // {
      //   field: "photo",
      //   headerName: "Photo",
      //   width: 150,
      //   renderCell: (params: any) => {
      //     const photo = params.value;
      //     if (photo) {
      //       let retryAttempted = false; // Flag to prevent infinite retries
      //       return (
      //         <img
      //           src={photo.url}
      //           onError={async (e) => {
      //             if (retryAttempted) {
      //               console.error(
      //                 "Image refresh already attempted, skipping retry"
      //               );
      //               return;
      //             }
      //             retryAttempted = true;

      //             console.error("Image failed to load, refreshing URL...");
      //             const img = e.currentTarget as HTMLImageElement | null;
      //             if (!img) return;

      //             try {
      //               const token = await getOrRefreshFirebaseToken();
      //               const new_url = await refreshFileUrl(
      //                 photo.id,
      //                 token,
      //                 prefix
      //               );
      //               img.src = new_url;
      //               let ref = getRefFromId("folder", params.row.id);
      //               updateDocDataFieldApi(
      //                 ref!,
      //                 "infos.photo_facade",
      //                 {
      //                   url: new_url,
      //                 },
      //                 prefix
      //               );
      //               rows = rows.map((row: any) => {
      //                 if (row.id === params.row.id) {
      //                   return {
      //                     ...row,
      //                     photo: { url: new_url, id: photo.id },
      //                   };
      //                 }
      //                 return row;
      //               });
      //             } catch (err) {
      //               console.error("Failed to refresh image URL", err);
      //             }
      //           }}
      //           alt="Folder Facade"
      //           className="w-32 h-16 object-cover rounded-md"
      //         />
      //       );
      //     }
      //     return (
      //       <div className="w-32 h-16 bg-gray-100 rounded-md flex items-center justify-center">
      //         <Icon1 name="image" size={20} color="grey"></Icon1>
      //       </div>
      //     );
      //   },
      // },
      // { field: "num", headerName: "Numéro", width: 100 },

      {
        field: "name",
        headerName: "Nom",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => {
          return (
            <div
              className={`flex flex-row gap-1 items-center font-medium text-black h-6 ${
                params.row.all_blocked
                  ? "text-red-500  bg-red-100 rounded-full inline-flex  px-2 "
                  : ""
              }`}
            >
              {params.row.all_blocked && (
                <div className="">
                  <Icon1 name="warning" size={18} color="red"></Icon1>
                </div>
              )}
              {params.value}
            </div>
          );
        },
      },
      { field: "city", headerName: "Ville", width: 130 },
      {
        field: "commercial",
        headerName: "Commercial",
        width: 130,

        renderCell: (params: any) => {
          let user = params.value;
          return (
            <div className="flex flex-row gap-1 items-center">
              <MemberAssignmentItem
                currentUserId={user.id}
                memberName={user.name}
                memberColor={user.color}
                assignMemberToRole={() => {}}
                users={orgUsers}
              />
            </div>
          );
        },
      },
      {
        field: "comptability",
        headerName: "Comptabilité",
        width: 130,

        renderCell: (params: any) => {
          let user = params.value;
          return (
            <div className=" flex-row gap-1 items-center ">
              <MemberAssignmentItem
                currentUserId={user.id}
                memberName={user.name}
                memberColor={user.color}
                assignMemberToRole={() => {}}
                users={orgUsers}
              />
            </div>
          );
        },
      },
      {
        field: "creation_date",
        headerName: "Creation",
        width: 150,
        renderCell: (params: any) => {
          // Customize color based on status value
          const date_int = params.value;

          const date = new Date(date_int);
          return (
            <div>
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      {
        field: "status",
        headerName: "Statut",
        width: 160,

        renderCell: (param: any) => {
          const status = param.value;
          const config = projectStatusDisplay[status] || {
            label: status,
            type: "default" as const,
          };
          return <StatusBlock type={config.type} label={config.label} />;
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = allfolders.map((folder: ProjectSummary, index: number) => ({
      id: folder.id || index + 1, // Use client's ID or default index
      num: folder.infos.general.num || "ddd", // Use client's number or default
      name: folder.infos.general.name?.trim() || "", // Use client's name or default 'Unknown'
      city: folder.infos.general.city || "", // Use client's type or default
      creation_date: folder.infos.general.creation_date.seconds * 1000 || 0,
      photo: folder.infos.general.photo_file?.url || "",
      status: folder.status || "ok", // Use client's status or default
      commercial:
        orgUsers.find((user) => user.id === folder.infos.team.commercial_id) ||
        {},
      comptability:
        orgUsers.find(
          (user) => user.id === folder.infos.team.comptability_id,
        ) || {},

      state: "ok", // Use client's city or default
      // Use client's city or default
    }));

    rows = rows.sort((a: any, b: any) => {
      return a.name
        .trim()
        .toLowerCase()

        .localeCompare(b.name.toLowerCase().trim());
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformPartnersToTable(
  partners: PartnerInfos[],
  activeTab: string = "all",
  searchValue: string = "",
) {
  try {
    let filtered = partners;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((p) => p.company_types?.includes(activeTab));
    }

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter(
        (p) =>
          p.display_name?.toLowerCase().includes(search) ||
          p.company_name?.toLowerCase().includes(search) ||
          p.role?.toLowerCase().includes(search),
      );
    }

    const columns = [
      {
        field: "company_name",
        headerName: "Entreprise",
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      { field: "display_name", headerName: "Nom", width: 180 },
      {
        field: "company_types",
        headerName: "Type",
        width: 180,
        renderCell: (params: any) => {
          const types = params.value as string[];
          if (!types || types.length === 0) return null;
          return (
            <div className="flex flex-row gap-1 flex-wrap">
              {types.map((t: string) => (
                <StatusBlock
                  key={t}
                  type="info"
                  label={companyTypeLabels[t] || t}
                />
              ))}
            </div>
          );
        },
      },
      { field: "email", headerName: "Email", width: 200 },
      { field: "phone_number", headerName: "Téléphone", width: 140 },
      {
        field: "decennales_count",
        headerName: "Décennales",
        width: 90,
        renderCell: (params: any) => {
          const count = params.value as number;
          if (!count) return null;
          return (
            <div className="flex flex-row items-center gap-1 text-neutral-500">
              <Icon1 name="file" size={16} />
              {count > 1 && <span className="text-h3 font-medium">{count}</span>}
            </div>
          );
        },
      },
    ];

    const rows = filtered
      .map((p) => ({
        id: p.id,
        display_name: p.display_name || "",
        company_name: p.company_name || "",
        role: p.role || "",
        company_types: p.company_types || ["autre"],
        email: p.email || p.company_email || "",
        phone_number: p.phone_number || p.company_phone || "",
        decennales_count: p.decennales?.length || 0,
      }))
      .sort((a, b) =>
        a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase()),
      );

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformBroadcastsToTable(
  broadcasts: Broadcast[],
  activeTab: string = "all",
  searchValue: string = "",
) {
  try {
    let filtered = broadcasts;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((b) => b.status === activeTab);
    }

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter(
        (b) =>
          b.title?.toLowerCase().includes(search) ||
          b.content?.toLowerCase().includes(search) ||
          b.author.display_name?.toLowerCase().includes(search),
      );
    }

    const columns = [
      {
        field: "title",
        headerName: "Titre",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      {
        field: "content",
        headerName: "Contenu",
        width: 250,
        renderCell: (params: any) => (
          <div className="text-neutral-500 truncate">
            {params.value?.length > 50
              ? params.value.slice(0, 50) + "..."
              : params.value}
          </div>
        ),
      },
      {
        field: "author",
        headerName: "Auteur",
        width: 140,
        renderCell: (params: any) => (
          <div
            className="rounded-full px-3 py-1 text-white font-medium text-h3 w-fit"
            style={{ backgroundColor: params.value?.color_tag || "#6B7280" }}
          >
            {params.value?.display_name}
          </div>
        ),
      },
      {
        field: "start_date",
        headerName: "Début",
        width: 130,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          );
        },
      },
      {
        field: "end_date",
        headerName: "Fin",
        width: 130,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          );
        },
      },
      {
        field: "status",
        headerName: "État",
        width: 120,
        renderCell: (params: any) => (
          <StatusBlock
            type={params.value === "active" ? "success" : "default"}
            label={params.value === "active" ? "Active" : "Inactive"}
          />
        ),
      },
    ];

    const rows = filtered
      .map((b) => ({
        id: b.id,
        title: b.title || "",
        content: b.content || "",
        author: b.author,
        start_date: b.start_date.seconds * 1000,
        end_date: b.end_date.seconds * 1000,
        status: b.status,
      }))
      .sort((a, b) => b.start_date - a.start_date);

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

const TAG_CONFIG: Record<DossierTag, { label: string; bg: string }> = {
  vip: { label: "VIP", bg: "#F87171" },
  professionnel: { label: "Professionnel", bg: "#A78BFA" },
  particulier: { label: "Particulier", bg: "#C4B5FD" },
  leasing: { label: "Leasing", bg: "#818CF8" },
  litige: { label: "Litige", bg: "#6366F1" },
  "sous-traitance": { label: "Sous-traitance", bg: "#34D399" },
};

export function transformDossiersToTable(
  dossiers: Dossier[],
  activeTab: string = "all",
) {
  try {
    let filtered = dossiers;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((d) => d.type === activeTab);
    }

    const columns = [
      {
        field: "name",
        headerName: "Nom",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      {
        field: "tags",
        headerName: "Tags",
        width: 200,
        renderCell: (params: any) => {
          const tags = params.value as DossierTag[];
          if (!tags || tags.length === 0) return null;
          return (
            <div className="flex flex-row gap-1 flex-wrap">
              {tags.map((tag: DossierTag) => {
                const config = TAG_CONFIG[tag] || { label: tag, bg: "#A1A1A1" };
                return (
                  <span
                    key={tag}
                    className="text-h3 whitespace-nowrap"
                    style={{ background: config.bg, color: "#FFFFFF", borderRadius: 30, padding: "4px 14px", lineHeight: "18px" }}
                  >
                    {config.label}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      { field: "phone", headerName: "Téléphone", width: 160 },
      {
        field: "last_activity",
        headerName: "Dernière activité",
        width: 180,
        renderCell: (params: any) => {
          if (!params.value) return null;
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}{" "}
              {date.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },
      {
        field: "notifications",
        headerName: "Notifications",
        width: 150,
        renderCell: (params: any) => {
          const notif = params.value;
          if (!notif?.unread) return null;
          const time = notif.last_message_time
            ? new Date(notif.last_message_time)
            : null;
          const now = new Date();
          let timeLabel = "";
          if (time) {
            const diffMs = now.getTime() - time.getTime();
            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            if (diffDays === 0) {
              timeLabel = time.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
            } else if (diffDays === 1) {
              timeLabel = time.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) + " Hier";
            } else {
              timeLabel = time.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });
            }
          }
          return (
            <div className="flex flex-row items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 flex-shrink-0" />
              <span className="text-neutral-600">{timeLabel}</span>
            </div>
          );
        },
      },
    ];

    const rows = filtered
      .map((d) => ({
        id: d.id,
        name: d.name || "",
        tags: d.tags || [],
        phone: d.phone || "",
        last_activity: d.last_activity ? d.last_activity.seconds * 1000 : null,
        notifications: d.notifications
          ? {
              unread: d.notifications.unread,
              last_message_time: d.notifications.last_message_time
                ? d.notifications.last_message_time.seconds * 1000
                : null,
            }
          : null,
      }))
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformEmailsSentToTable(
  sentEmails: EmailSent[],
  projects: ProjectSummary[],
  searchValue: string = "",
) {
  try {
    let filtered = sentEmails;

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter((e) => {
        const projectName =
          projects
            .find((p) => p.id === e.project_id)
            ?.infos.general.name?.toLowerCase() || "";
        return (
          e.subject?.toLowerCase().includes(search) ||
          e.emails_to?.some((addr) => addr.toLowerCase().includes(search)) ||
          projectName.includes(search)
        );
      });
    }

    const columns = [
      {
        field: "subject",
        headerName: "Sujet",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black truncate">{params.value}</div>
        ),
      },
      {
        field: "recipients",
        headerName: "Destinataires",
        width: 200,
        renderCell: (params: any) => (
          <div className="text-neutral-500 truncate">{params.value}</div>
        ),
      },
      { field: "project_name", headerName: "Projet", width: 150 },
      {
        field: "date",
        headerName: "Date",
        width: 150,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}{" "}
              {date.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },
    ];

    const rows = filtered
      .map((e) => ({
        id: e.id,
        subject: e.subject || "",
        recipients: e.emails_to?.join(", ") || "",
        project_name:
          projects.find((p) => p.id === e.project_id)?.infos.general.name || "",
        date: e.created_at.seconds * 1000,
      }))
      .sort((a, b) => b.date - a.date);

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

const ORDRE_TAG_CONFIG: Record<OrdreTag, { label: string; bg: string }> = {
  huile: { label: "HUILE", bg: "#F9A8D4" },
  diag: { label: "DIAG", bg: "#A78BFA" },
  pieces_en_attente: { label: "PIECES EN ATTENTE", bg: "#C4B5FD" },
  accidente: { label: "ACCIDENTE", bg: "#818CF8" },
  assurance: { label: "ASSURANCE", bg: "#A5B4FC" },
};

const ORDRE_STATUS_CONFIG: Record<string, { label: string; bg: string; color: string }> = {
  a_preparer: { label: "en prépa", bg: "#F4F4F4", color: "#A1A1A1" },
  commande: { label: "commande", bg: "#F4F4F4", color: "#A1A1A1" },
  pret: { label: "prêt", bg: "#F4F4F4", color: "#A1A1A1" },
  reception: { label: "réception", bg: "#F4F4F4", color: "#A1A1A1" },
  en_cours: { label: "en cours", bg: "#CACFFF", color: "#5C6BFF" },
  devis: { label: "devis", bg: "#F4F4F4", color: "#A1A1A1" },
  accord: { label: "accord", bg: "#F4F4F4", color: "#A1A1A1" },
  fin_de_travaux: { label: "fin de travaux", bg: "#F4F4F4", color: "#A1A1A1" },
  facturation: { label: "facturation", bg: "#F4F4F4", color: "#A1A1A1" },
  disponible: { label: "disponible", bg: "#F1E7F9", color: "#8258FF" },
  restitue: { label: "restitué", bg: "#E3FEFC", color: "#5EEAD4" },
  signature: { label: "signature", bg: "#F4F4F4", color: "#A1A1A1" },
};

export function transformOrdresToTable(
  ordres: Ordre[],
  activeTab: string = "all",
) {
  try {
    let filtered = ordres;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((o) => o.status === activeTab);
    }

    const columns = [
      { field: "num", headerName: "Num", width: 130 },
      {
        field: "name",
        headerName: "Nom",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black truncate">{params.value}</div>
        ),
      },
      {
        field: "tags",
        headerName: "Tags",
        width: 200,
        renderCell: (params: any) => {
          const tags = params.value as OrdreTag[];
          if (!tags || tags.length === 0) return null;
          return (
            <div className="flex flex-row items-center gap-[5px] flex-wrap">
              {tags.map((tag: OrdreTag) => {
                const config = ORDRE_TAG_CONFIG[tag] || { label: tag, bg: "#F4F4F4" };
                return (
                  <span
                    key={tag}
                    className="text-h3 whitespace-nowrap"
                    style={{ background: config.bg, color: "#FFFFFF", borderRadius: 30, padding: "4px 14px", lineHeight: "18px" }}
                  >
                    {config.label}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        field: "status",
        headerName: "Status",
        width: 145,
        renderCell: (params: any) => {
          const status = params.value as string;
          const config = ORDRE_STATUS_CONFIG[status] || { label: status, bg: "#F4F4F4", color: "#A1A1A1" };
          return (
            <span
              className="text-h3 whitespace-nowrap"
              style={{ background: config.bg, color: config.color, borderRadius: 5, padding: "4px 14px", lineHeight: "18px" }}
            >
              {config.label}
            </span>
          );
        },
      },
      {
        field: "restitution",
        headerName: "Restitution",
        width: 175,
        renderCell: (params: any) => {
          if (!params.value) return null;
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}{" "}
              {date.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },
      { field: "modele", headerName: "Modèle", width: 150 },
      { field: "immatriculation", headerName: "IMMA", width: 140 },
      {
        field: "campagne",
        headerName: "Campagne",
        width: 145,
        renderCell: (params: any) => {
          if (!params.value) return null;
          return <div>{params.value}</div>;
        },
      },
    ];

    const rows = filtered.map((o) => ({
      id: o.id,
      num: o.num || "",
      name: o.name || "",
      tags: o.tags || [],
      status: o.status || "",
      restitution: o.restitution ? o.restitution.seconds * 1000 : null,
      modele: o.modele || "",
      immatriculation: o.immatriculation || "",
      campagne: o.campagne || "",
    }));

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

const VEHICLE_TAG_CONFIG: Record<VehicleTag, { label: string; bg: string }> = {
  huile: { label: "HUILE", bg: "#F9A8D4" },
  rendu_sale: { label: "Rendu sale", bg: "#F87171" },
  reserve: { label: "Réservé", bg: "#A78BFA" },
  assurance: { label: "Assurance", bg: "#A5B4FC" },
  a_sortir: { label: "À sortir du parc", bg: "#C4B5FD" },
  plein_fait: { label: "Plein fait", bg: "#60A5FA" },
  hors_service: { label: "Hors service", bg: "#818CF8" },
};

const VEHICLE_STATUS_CONFIG: Record<VehicleStatus, { label: string; style: string }> = {
  disponible: { label: "disponible", style: "text-neutral-500" },
  en_cours: { label: "en cours", style: "text-blue-500 bg-blue-50 border border-blue-200" },
  hors_service: { label: "hors service", style: "text-red-500 bg-red-50 border border-red-200" },
  reserve: { label: "réservé", style: "text-purple-500 bg-purple-50 border border-purple-200" },
};

function computeVehicleAvailability(
  vehicleId: string,
  reservations: VehicleReservation[],
): { currentlyRented: boolean; clientName?: string; returnDate?: string; upcomingCount: number } {
  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  const vehicleRes = reservations.filter((r) => r.vehicleId === vehicleId);
  const current = vehicleRes.find((r) => r.startDate <= todayStr && r.endDate >= todayStr);
  const upcoming = vehicleRes.filter((r) => r.startDate > todayStr);

  return {
    currentlyRented: !!current,
    clientName: current?.clientName,
    returnDate: current?.endDate,
    upcomingCount: upcoming.length,
  };
}

export function transformVehiclesToTable(
  vehicles: Vehicle[],
  activeTab: string = "tous",
  reservations: VehicleReservation[] = [],
) {
  try {
    let filtered = vehicles;

    if (activeTab && activeTab !== "tous") {
      filtered = filtered.filter((v) => v.fuel_type === activeTab);
    }

    const columns = [
      {
        field: "plate",
        headerName: "IMMA",
        width: 130,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      {
        field: "designation",
        headerName: "Designation",
        flex: 1,
        minWidth: 180,
      },
      {
        field: "has_print",
        headerName: "Type",
        width: 60,
        renderCell: (params: any) => {
          if (!params.value) return null;
          return <Icon1 name="print" size={16} color="#A1A1A1" />;
        },
      },
      {
        field: "tags",
        headerName: "Tags",
        width: 250,
        renderCell: (params: any) => {
          const tags = params.value as VehicleTag[];
          if (!tags || tags.length === 0) return null;
          return (
            <div className="flex flex-row gap-1 flex-wrap">
              {tags.map((tag: VehicleTag) => {
                const config = VEHICLE_TAG_CONFIG[tag] || { label: tag, bg: "#A1A1A1" };
                return (
                  <span
                    key={tag}
                    className="text-h4 whitespace-nowrap"
                    style={{ background: config.bg, color: "#FFFFFF", borderRadius: 30, padding: "4px 14px", lineHeight: "18px" }}
                  >
                    {config.label}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        field: "modele",
        headerName: "Modèle",
        width: 140,
      },
      {
        field: "status",
        headerName: "Status",
        width: 200,
        renderCell: (params: any) => {
          const row = params.row;
          const status = row.rawStatus as VehicleStatus;

          // Hors service is a manual override
          if (status === "hors_service") {
            return (
              <span className="text-red-500 bg-red-50 border border-red-200 rounded-full px-3 py-1 text-h3 font-medium whitespace-nowrap">
                hors service
              </span>
            );
          }

          const availability = row.availability as { currentlyRented: boolean; clientName?: string; returnDate?: string; upcomingCount: number };

          if (availability.currentlyRented) {
            const returnLabel = availability.returnDate
              ? ` → ${availability.returnDate.split("-").reverse().join("/")}`
              : "";
            return (
              <div className="flex flex-row items-center gap-1.5">
                <span className="text-blue-500 bg-blue-50 border border-blue-200 rounded-full px-3 py-1 text-h3 font-medium whitespace-nowrap">
                  en prêt{returnLabel}
                </span>
              </div>
            );
          }

          return (
            <div className="flex flex-row items-center gap-1.5">
              <span className="text-neutral-500 text-h3 font-medium">disponible</span>
              {availability.upcomingCount > 0 && (
                <span className="text-purple-500 bg-purple-50 border border-purple-200 rounded-full px-2 py-0.5 text-h4 font-medium whitespace-nowrap">
                  {availability.upcomingCount} résa.
                </span>
              )}
            </div>
          );
        },
      },
    ];

    const rows = filtered.map((v) => ({
      id: v.id,
      plate: v.plate,
      designation: v.designation,
      has_print: v.has_print,
      tags: v.tags || [],
      modele: v.modele || "",
      status: v.status || "disponible",
      rawStatus: v.status || "disponible",
      availability: computeVehicleAvailability(v.id, reservations),
    }));

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}
